/**
 * Shared comments-tab shell for post profile pages.
 */
import React from "react";
import { useParams } from "react-router-dom";
import CommentsSection from "components/Comments/CommentsSection";
import {
  getPostCommentMeta,
  getPostDisplayDefinition,
} from "components/Posts/display/postDisplayConfig";
import type { PostDisplayKind } from "components/Posts/display/postDisplayTypes";
import ScrollHideContainer from "ui/ScrollHideContainer";
import ScrollableTabsList from "ui/ScrollableTabsList";

interface PostCommentsTabsProps {
  kind: PostDisplayKind;
  entityId: number;
  entityTitle?: string | null;
}

const PostCommentsTabs: React.FC<PostCommentsTabsProps> = ({ kind, entityId, entityTitle }) => {
  const { id, tab } = useParams<{ id: string; tab?: string }>();
  const selectedTab = tab || "comments";
  const definition = getPostDisplayDefinition(kind);
  const commentMeta = getPostCommentMeta(kind);

  const tabs = [
    {
      label: commentMeta.tabLabel,
      route: `${commentMeta.routeBase}/${id}/comments`,
      value: "comments",
    },
  ];

  const pageTitle = entityTitle?.trim()
    ? `${definition.label} - ${entityTitle}`
    : definition.label;

  return (
    <div className="py-0 relative">
      <ScrollHideContainer
        className="z-50 max-w-5xl bg-eoe-bg dark:bg-eoe-dark-bg"
        hideOffset={57}
        threshold={56}
      >
        <div className="p-2">
          <ScrollableTabsList
            key={`${kind}-${id}-tabs`}
            tabs={tabs}
            selectedTab={selectedTab}
            onTabChange={() => {}}
            pageTitle={pageTitle}
          />
        </div>
      </ScrollHideContainer>
      <div className="py-0 relative">
        {selectedTab === "comments" && (
          <CommentsSection
            commentable_id={entityId}
            commentable_type={commentMeta.commentableType}
            isEntitySection={true}
          />
        )}
      </div>
    </div>
  );
};

export default PostCommentsTabs;
